import "@/App.css";
import "leaflet/dist/leaflet.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import EventEditor from "@/pages/EventEditor";
import PrintPlan from "@/pages/PrintPlan";
import ServiceSheets from "@/pages/ServiceSheets";
import CompareEditions from "@/pages/CompareEditions";
import AgentMobile from "@/pages/AgentMobile";
import Users from "@/pages/Users";
import Manual from "@/pages/Manual";

const Loading = () => (
  <div className="min-h-screen grid place-items-center bg-[#0b1329] text-slate-400 font-mono text-xs tracking-widest" data-testid="app-loading">
    CARGANDO CENTRO DE MANDO…
  </div>
);

const Protected = ({ children, admin }) => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const LoginRoute = () => {
  const { user } = useAuth();
  if (user === null) return <Loading />;
  return user ? <Navigate to="/" replace /> : <Login />;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginRoute />} />
          <Route path="/m/:token/:unit" element={<AgentMobile />} />
          <Route path="/events/:id/print" element={<Protected><PrintPlan /></Protected>} />
          <Route path="/events/:id/sheets" element={<Protected><ServiceSheets /></Protected>} />
          <Route element={<Protected><Layout /></Protected>}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/events/:id" element={<EventEditor />} />
            <Route path="/events/:id/compare" element={<CompareEditions />} />
            <Route path="/users" element={<Protected admin><Users /></Protected>} />
            <Route path="/manual" element={<Manual />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" theme="dark" richColors />
    </AuthProvider>
  );
}

export default App;
